'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = mux;

var _isPlainObject = require('lodash/isPlainObject');

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mux(promises) {
  if (promises == null) {
    return promises;
  }

  if (typeof promises.then === 'function') {
    return promises.then(mux);
  }

  if (Array.isArray(promises)) {
    return Promise.all(promises.map(mux));
  }

  if ((0, _isPlainObject2.default)(promises)) {
    var keys = Object.keys(promises);
    var values = [];
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var key = _step.value;

        values.push(promises[key]);
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    return Promise.all(values.map(mux)).then(function (values) {
      var result = Object.create(Object.getPrototypeOf(promises));
      var keyCount = keys.length;
      for (var ii = 0; ii < keyCount; ii++) {
        result[keys[ii]] = values[ii];
      }
      return result;
    });
  }

  return promises;
} /**
   * Mux by ide
   *
   * Included as application code because it does not export ES5 code,
   * resulting in failed minification in Create-React-App and others.
   *
   * This is mux as of version 1.0.7.
   *
   * https://github.com/ide/mux
   */